module.exports = __webpack_public_path__ + "540170fca035cfda2659152e57c803f5.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_70.mp3
// module id = 420
// module chunks = 0